import ApiService from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'

import { LOGOUT } from './auth.module.js'
import router from '@/router'

import Favico from 'favico.js/favico.js'

import { eventBus } from '@/main'

// action types
export const GET_EVENTS_COUNT = 'getEventsCount'
export const GET_EVENTS_LIST = 'getEventsList'
export const SELECT_ALL_EVENTS = 'selectAllEvents'
export const DELETE_EVENTS = 'deleteEvents'
export const DELETE_ALL_EVENTS = 'deleteAllEvents'

// mutation types
export const SAVE_EVENTS_COUNT = 'saveEventsCount'
export const SAVE_EVENTS_LIST = 'saveEventsList'
export const CLEAR_EVENTS_LIST = 'clearEventsList'
export const SAVE_EVENTS_PAGES = 'saveEventsPages'
export const CLEAR_EVENTS_PAGES = 'clearEventsPages'
export const SELECT_EVENT = 'selectEvent'
export const DESELECT_ALL_EVENTS = 'deselectAllEvents'
export const CLEAR_SELECTED_EVENTS = 'clearSelectedEvents'
export const DELETE_SELECTED_EVENTS = 'deleteSelectedEvents'

const SET_RESPONSE_STATE = 'setResponseState'
const TOAST_NOTIFICATIONS = 'showToast/Notifications'

var favicon = new Favico({
  animation: 'none',
  fontFamily: 'Inter',
  bgColor: '#FFFFFF',
  textColor: '#212121',
  position : 'up',
})

const state = {
  eventsList: [],
  eventStats: {
    current_page: 0,
    total_pages: undefined,
    total_elements: undefined,
  },
  selectedEvents: [],

  responses: {
    getEventsCount: false,
    getEventsList: false,
    deleteEvents: false,
  },
}

const getters = {
  totalEventsElements(state) {
    return state.eventStats.total_elements || 0
  },
  eventsElementsEmpty(state) {
    return state.eventStats.total_elements == 0
  },
  eventsList(state) {
    return state.eventsList
  },
  nextPage(state) {
    return state.eventStats.current_page + 1
  },
  nextPageAvailable(state) {
    return state.eventStats.current_page < state.eventStats.total_pages
  },
  eventSelected: state => event => {
    return state.selectedEvents.some(i => i === event._id)
  },
  noEventsSelected(state) {
    return state.selectedEvents.length == 0
  },
  someEventsSelected(state) {
    return state.selectedEvents.length > 0
  },
  allEventsSelected(state) {
    return state.selectedEvents.length === state.eventsList.length
  },
  selectedEventsLength(state) {
    return state.selectedEvents.length
  },
  eventsResponses: state => type => {
    return state.responses[type]
  },
}

const actions = {
  [GET_EVENTS_COUNT](context) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        context.commit(SET_RESPONSE_STATE, { type: 'getEventsCount', status: true })
        ApiService.setHeader()
        ApiService.get(`${process.env.VUE_APP_EVENTS}/count`)
          .then(({ data }) => {
            context.commit(SAVE_EVENTS_COUNT, data.count)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            context.commit(SET_RESPONSE_STATE, { type: 'getEventsCount', status: false })
          })
      } else {
        context.dispatch(LOGOUT, null, { root: true })
          .then(() => router.push({ name: 'login' }))
          .catch(() => {})
      }
    })
  },
  [GET_EVENTS_LIST](context, { type }) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        context.commit(SET_RESPONSE_STATE, { type: 'getEventsList', status: true })
        eventBus.$emit('startProgress')
        ApiService.setHeader()
        ApiService.get(process.env.VUE_APP_EVENTS, {
          limit: 30,
          page: type == 'next' ? context.getters.nextPage : 1,
        })
          .then(({ data }) => {
            context.commit(SAVE_EVENTS_LIST, {
              list: data.list,
              type,
            })
            context.commit(SAVE_EVENTS_COUNT, data.total_elements)
            context.commit(SAVE_EVENTS_PAGES, {
              current_page: data.page,
              total_pages: data.total_pages
            })
            resolve(data)
          })
          .catch(err => {
            eventBus.$emit(TOAST_NOTIFICATIONS, {
              message: err.message,
              variant: 'danger'
            })
            reject(err)
          })
          .finally(() => {
            context.commit(SET_RESPONSE_STATE, { type: 'getEventsList', status: false })
            eventBus.$emit('endProgress')
          })
      } else {
        context.dispatch(LOGOUT, null, { root: true })
          .then(() => router.push({ name: 'login' }))
          .catch(() => {})
      }
    })
  },
  [SELECT_ALL_EVENTS](context) {
    context.commit(DESELECT_ALL_EVENTS)
    context.state.eventsList.forEach((event) => {
      context.commit(SELECT_EVENT, event)
    })
  },
  [DELETE_EVENTS](context) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        context.commit(SET_RESPONSE_STATE, { type: 'deleteEvents', status: true })
        eventBus.$emit('startProgress')
        ApiService.setHeader()
        const ids = context.state.selectedEvents.join(',')
        ApiService.delete(`${process.env.VUE_APP_EVENT}?ids=${ids}`)
          .then(({ data }) => {
            context.commit(DELETE_SELECTED_EVENTS)
            context.commit(CLEAR_SELECTED_EVENTS)
            context.dispatch(GET_EVENTS_LIST, { type: 'refresh' })
            eventBus.$emit(TOAST_NOTIFICATIONS, {
              message: data.message,
              variant: 'success'
            })
            resolve(data)
          })
          .catch(err => {
            eventBus.$emit(TOAST_NOTIFICATIONS, {
              message: err.message,
              variant: 'danger'
            })
            reject(err)
          })
          .finally(() => {
            context.commit(SET_RESPONSE_STATE, { type: 'deleteEvents', status: false })
            eventBus.$emit('endProgress')
          })
      } else {
        context.dispatch(LOGOUT, null, { root: true })
          .then(() => router.push({ name: 'login' }))
          .catch(() => {})
      }
    })
  },
  [DELETE_ALL_EVENTS](context) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken()) {
        context.commit(SET_RESPONSE_STATE, { type: 'deleteAllEvents', status: true })
        eventBus.$emit('startProgress')
        ApiService.setHeader()
        ApiService.delete(process.env.VUE_APP_EVENTS)
          .then(({ data }) => {
            context.commit(CLEAR_EVENTS_LIST)
            context.dispatch(GET_EVENTS_LIST, { type: 'refresh' })
            eventBus.$emit(TOAST_NOTIFICATIONS, {
              message: data.message,
              variant: 'success'
            })
            resolve(data)
          })
          .catch(err => {
            eventBus.$emit(TOAST_NOTIFICATIONS, {
              message: err.message,
              variant: 'danger'
            })
            reject(err)
          })
          .finally(() => {
            context.commit(SET_RESPONSE_STATE, { type: 'deleteAllEvents', status: false })
            eventBus.$emit('endProgress')
          })
      } else {
        context.dispatch(LOGOUT, null, { root: true })
          .then(() => router.push({ name: 'login' }))
          .catch(() => {})
      }
    })
  },
}

const mutations = {
  [SAVE_EVENTS_COUNT](state, count) {
    state.eventStats.total_elements = count
    if (count > 0) {
      favicon.badge(count)
    } else if (count == 0) {
      favicon.badge(0)
    }
  },
  [SAVE_EVENTS_LIST](state, { list, type }) {
    if (Array.isArray(list) && list.length > 0) {
      if (type == 'next') {
        for (let i = 0; i < list.length; i++) {
          state.eventsList.push(list[i])
        }
      } else if (type == 'refresh') {
        state.eventsList = list
      }
    }
  },
  [CLEAR_EVENTS_LIST](state) {
    state.eventsList = []
  },
  [SAVE_EVENTS_PAGES](state, { current_page, total_pages }) {
    state.eventStats.current_page = current_page
    state.eventStats.total_pages = total_pages
  },
  [CLEAR_EVENTS_PAGES](state) {
    state.eventStats.current_page = 0
    state.eventStats.total_pages = undefined
  },
  [SELECT_EVENT](state, event) {
    const index = state.selectedEvents.indexOf(event._id)
    if (index > -1) {
      state.selectedEvents.splice(index, 1)
    } else {
      state.selectedEvents.push(event._id)
    }
  },
  [DESELECT_ALL_EVENTS](state) {
    state.selectedEvents = []
  },
  [CLEAR_SELECTED_EVENTS](state) {
    state.selectedEvents = []
  },
  [DELETE_SELECTED_EVENTS](state) {
    state.selectedEvents.forEach(eventId => {
      const index = state.eventsList.findIndex(event => event._id === eventId)
      if (index !== -1) {
        state.eventsList.splice(index, 1)
      }
    })
  },
  [SET_RESPONSE_STATE](state, { type, status }) {
    state.responses[type] = status
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
